export default __webpack_public_path__ + "static/media/product-1-6.098cadba.jpg";